<div class="layout-wrapper">
  <p-toast [life]="7000" position="top-right" key="toast" />
  <div id="pagespinner">
    <app-progress-spinner
      [enabled]="
        notSupported === false &&
        (routeLoading || this.authenticated !== true) &&
        showLoadingScreen
      "
    />
  </div>

  @if (notSupported === true) {
    <p-message
      severity="error"
      text="{{ 'COMMON.MESSAGES.ERROR.BROWSER_NOT_SUPPORTED_MSG' | translate }}"
    />
  }

  <p-drawer
    [(visible)]="menuOpen"
    styleClass="nav-sidebar"
    [blockScroll]="true"
  >
    <div id="menu">
      <h3>{{ 'COMMON.LABEL.GCMC_MENU' | translate }}</h3>
      <hr />
      <app-menu
        [menuItems]="menuItems"
        [parentActive]="false"
        [version]="version"
      />
    </div>
  </p-drawer>

  <app-toolbar
    (menuToggle)="menuToggle()"
    [title]="toolbarTitle"
    [show]="this.authenticated"
  />

  @if (authenticated === true && isMobile()) {
    <p-breadcrumb
      [model]="breadCrumbs"
      [home]="homeItem"
      (onItemClick)="onBreadCrumbClick($event)"
      styleClass="route-bar"
    />
  }

  <div class="layout-main">
    @if (isAuthenticated) {
      @if (isMobile() && mobileTab) {
        <div>
          @if (mobileTab.container === 'MainContainerComponent') {
            <router-outlet />
          }
          @if (mobileTab.container === 'McLogSearchComponent') {
            <app-mc-log-search />
          }
          @if (mobileTab.container === 'McLogDetailsComponent') {
            <app-mc-log-details
              [id]="mobileTab.id"
              [index]="mobileTab.index"
              (changesEvent)="handleDetailChange($event)"
            />
          }
          @if (mobileTab.container === 'MobileControllerNotesSearch') {
            <app-mobile-controller-notes-search />
          }
          @if (mobileTab.container === 'MobileNoteForm') {
            <app-mobile-note-form
              [id]="mobileTab.id"
              [index]="mobileTab.index"
              (changesEvent)="handleDetailChange($event)"
            />
          }
          @if (mobileTab.container === 'FacilityVisitorLogComponent') {
            <app-facility-visitor-log [gotoFacilityId]="mobileTab.id" />
          }
          @if (
            mobileTab.container === 'CommercialContactsSearchContainerComponent'
          ) {
            <app-commercial-contacts-search-container />
          }
          @if (
            mobileTab.container === 'CommercialContactDetailsContainerComponent'
          ) {
            <app-commercial-contact-details-container
              [id]="mobileTab.id!"
              [index]="mobileTab.index"
              (changesEvent)="handleDetailChange($event)"
            />
          }
          @if (
            mobileTab.container ===
            'CommercialFacilitiesSearchContainerComponent'
          ) {
            <app-commercial-facilities-search-container />
          }
          @if (
            mobileTab.container ===
            'CommercialFacilityDetailsContainerComponent'
          ) {
            <app-commercial-facility-details-container
              [id]="mobileTab.id!"
              [index]="mobileTab.index"
              (changesEvent)="handleDetailChange($event)"
            />
          }
        </div>
      }
      @if (!isMobile()) {
        <p-tabs
          #tabs
          class="content-container"
          [value]="activeIndex"
          scrollable
        >
          <p-tablist>
            @for (item of openTabs; track item; let i = $index) {
              <p-tab [value]="i" (click)="changeActiveTab(i)">
                <div class="tab-header">
                  <span>
                    @if (item.header !== '') {
                      {{ item.header }}
                    } @else {
                      {{ 'COMMON.LABEL.DEFAULT_TAB_HEADER' | translate }}
                    }
                  </span>
                  @if (item.container === 'FieldVisionEmbedComponent') {
                    <button
                      pButton
                      type="button"
                      icon="pi pi-external-link"
                      (click)="popOutFieldVision()"
                      pTooltip="{{
                        'COMMON.LABEL.FV_POPOUT_TOOLTIP' | translate
                      }}"
                      tooltipPosition="bottom"
                      class="{{ item.selected ? '' : 'transparent-button' }}"
                    ></button>
                  }
                  @if (item.closable) {
                    <p-button
                      type="button"
                      (click)="closeTab(i)"
                      icon="pi pi-times"
                      class="tab-close-button"
                      [text]="activeIndex !== i"
                      size="small"
                    />
                  }
                </div>
              </p-tab>
            }
          </p-tablist>
          <p-tabpanels>
            @for (item of openTabs; track item; let i = $index) {
              <p-tabpanel [value]="i">
                <div>
                  <div>
                    @if (isAuthenticated && item.routerLink) {
                      <router-outlet (activate)="onActivate(item)" />
                    }
                    @if (item.container === 'MonlogsSearchContainerComponent') {
                      <app-monlogs-search-container />
                    }
                    @if (item.container === 'MonlogsDetailContainerComponent') {
                      <app-monlogs-detail-container
                        [id]="item.id!"
                        [index]="item.index"
                        (changesEvent)="handleDetailChange($event)"
                      />
                    }
                    @if (item.container === 'MonLogPrintContainerComponent') {
                      <app-mon-log-print-container [id]="item.id!" />
                    }
                    @if (
                      item.container ===
                      'MonlogsAllLogsSearchContainerComponent'
                    ) {
                      <app-monlogs-all-logs-search-container />
                    }
                    @if (item.container === 'OplogsDetailContainerComponent') {
                      <app-oplogs-detail-container
                        [id]="item.id!"
                        [index]="item.index"
                        (changesEvent)="handleDetailChange($event)"
                      />
                    }
                    @if (
                      item.container === 'OpAlertLogPrintContainerComponent'
                    ) {
                      <app-op-alert-log-print-container [id]="item.id!" />
                    }
                    @if (
                      item.container === 'OplogsAllLogsSearchContainerComponent'
                    ) {
                      <app-oplogs-all-logs-search-container />
                    }
                    @if (
                      item.container === 'AlarmLimitsSearchContainerComponent'
                    ) {
                      <app-alarm-limits-search-container />
                    }
                    @if (
                      item.container === 'SyncAlarmLimitsContainerComponent'
                    ) {
                      <app-sync-alarm-limits-container />
                    }
                    @if (
                      item.container === 'StationLogsSearchContainerComponent'
                    ) {
                      <app-station-logs-search-container />
                    }
                    @if (
                      item.container === 'MusterListSearchContainerComponent'
                    ) {
                      <app-muster-list-search-container />
                    }
                    @if (
                      item.container === 'McShiftTurnoverContainerComponent'
                    ) {
                      <app-mc-shift-turnover-container />
                    }
                    @if (item.container === 'McShiftTurnoverDetailComponent') {
                      <app-mc-shift-turnover-detail
                        [id]="item.id!"
                        [index]="item.index"
                        (changesEvent)="handleDetailChange($event)"
                      />
                    }
                    @if (
                      item.container ===
                      'McShiftTurnoverPrintContainerComponent'
                    ) {
                      <app-mc-shift-turnover-print-container [id]="item.id!" />
                    }
                    @if (item.container === 'FacilityContainerComponent') {
                      <app-facility-container />
                    }
                    @if (
                      item.container === 'FacilityDetailsContainerComponent'
                    ) {
                      <app-facility-details-container
                        [id]="item.id!"
                        [index]="item.index"
                        (changesEvent)="handleDetailChange($event)"
                      />
                    }
                    @if (item.container === 'LocationContainerComponent') {
                      <app-location-container />
                    }
                    @if (
                      item.container === 'ContactProfileContainerComponent'
                    ) {
                      <app-contact-profile-container />
                    }
                    @if (
                      item.container === 'ContactsSearchContainerComponent'
                    ) {
                      <app-contacts-search-container />
                    }
                    @if (
                      item.container === 'ContactDetailsContainerComponent'
                    ) {
                      <app-contact-details-container
                        [id]="item.id!"
                        [index]="item.index"
                        (changesEvent)="handleDetailChange($event)"
                      />
                    }
                    @if (
                      item.container === 'ContactListSearchContainerComponent'
                    ) {
                      <app-contact-list-search-container />
                    }
                    @if (
                      item.container ===
                      'ContactListDetailViewContainerComponent'
                    ) {
                      <app-contact-list-detail-view-container
                        [id]="item.id!"
                        [index]="item.index"
                        (changesEvent)="handleDetailChange($event)"
                      />
                    }
                    @if (
                      item.container === 'ContactListCreateContainerComponent'
                    ) {
                      <app-contact-list-create-container />
                    }
                    @if (
                      item.container ===
                      'ExternalContactListSearchContainerComponent'
                    ) {
                      <app-external-contact-list-search-container />
                    }
                    @if (
                      item.container ===
                      'ExternalContactListDetailsContainerComponent'
                    ) {
                      <app-external-contact-list-details-container
                        [id]="item.id!"
                        [index]="item.index"
                        (changesEvent)="handleDetailChange($event)"
                      />
                    }
                    @if (item.container === 'GisMapComponent') {
                      <app-gis-map />
                    }
                    @if (item.container === 'FieldVisionEmbedComponent') {
                      <app-field-vision-embed />
                    }
                    @if (
                      item.container === 'ControllerNotesContainerComponent'
                    ) {
                      <app-controller-notes-container />
                    }
                    @if (item.container === 'NoteFormComponent') {
                      <app-note-form [id]="item.id!" />
                    }
                    @if (
                      item.container === 'DailyOperatingPlansContainerComponent'
                    ) {
                      <app-daily-operating-plans-container />
                    }
                    @if (item.container === 'AorViewComponent') {
                      <app-aor-view [data]="item.data!" />
                    }
                    @if (
                      item.container === 'CrmShiftTurnoverContainerComponent'
                    ) {
                      <app-crm-shift-turnover-container />
                    }
                    @if (
                      item.container ===
                      'CrmShiftTurnoverDetailsContainerComponent'
                    ) {
                      <app-crm-shift-turnover-details-container
                        [id]="item.id!"
                        [index]="item.index"
                        (changesEvent)="handleDetailChange($event)"
                      />
                    }
                    @if (
                      item.container ===
                      'CrmShiftTurnoverPrintContainerComponent'
                    ) {
                      <app-crm-shift-turnover-print-container [id]="item.id!" />
                    }
                    @if (item.container === 'EmailGroupContainerComponent') {
                      <app-email-group-container />
                    }
                    @if (item.container === 'MonLogTypesContainerComponent') {
                      <app-mon-log-types-container />
                    }
                    @if (item.container === 'NoteTypesContainerComponent') {
                      <app-note-types-container />
                    }
                    @if (item.container === 'JobRolesContainerComponent') {
                      <app-job-roles-container />
                    }
                    @if (item.container === 'CompanyContainerComponent') {
                      <app-company-container />
                    }
                    @if (
                      item.container === 'MocEventSearchContainerComponent'
                    ) {
                      <app-moc-event-search-container />
                    }
                    @if (
                      item.container === 'MocEventDetailsContainerComponent'
                    ) {
                      <app-moc-event-details-container [id]="item.id!" />
                    }
                    @if (
                      item.container === 'MocEventCategoryContainerComponent'
                    ) {
                      <app-moc-event-category-container />
                    }
                    @if (
                      item.container === 'RoleClaimAssignContainerComponent'
                    ) {
                      <app-role-claim-assign-container />
                    }
                    @if (
                      item.container === 'ClaimRoleAssignContainerComponent'
                    ) {
                      <app-claim-role-assign-container />
                    }
                    @if (
                      item.container ===
                      'RoleBusinessUnitAssignContainerComponent'
                    ) {
                      <app-role-business-unit-assign-container />
                    }
                    @if (item.container === 'AreaContainerComponent') {
                      <app-area-container />
                    }
                    @if (item.container === 'AreaDetailsContainerComponent') {
                      <app-area-details-container
                        [id]="item.id!"
                        [index]="item.index"
                        (changesEvent)="handleDetailChange($event)"
                      />
                    }
                    @if (item.container === 'RegionContainerComponent') {
                      <app-region-container />
                    }
                    @if (item.container === 'RegionDetailsContainerComponent') {
                      <app-region-details-container
                        [id]="item.id!"
                        [index]="item.index"
                        (changesEvent)="handleDetailChange($event)"
                      />
                    }
                    @if (item.container === 'SapOutageReportComponent') {
                      <app-sap-outage-report />
                    }
                    @if (item.container === 'ReadOnlySapViewComponent') {
                      <app-read-only-sap-view [id]="item.id!" />
                    }
                    @if (item.container === 'PartsSearchContainerComponent') {
                      <app-parts-search-container />
                    }
                    @if (
                      item.container ===
                      'TroubleshootingSearchContainerComponent'
                    ) {
                      <app-troubleshooting-search-container />
                    }
                    @if (item.container === 'McLogSearchComponent') {
                      <app-mc-log-search />
                    }
                    @if (item.container === 'FacilityVisitorLogComponent') {
                      <app-facility-visitor-log [gotoFacilityId]="item.id!" />
                    }
                    @if (
                      item.container ===
                      'CommercialContactsSearchContainerComponent'
                    ) {
                      <app-commercial-contacts-search-container />
                    }
                    @if (
                      item.container ===
                      'CommercialContactDetailsContainerComponent'
                    ) {
                      <app-commercial-contact-details-container
                        [id]="item.id!"
                        [index]="item.index"
                        (changesEvent)="handleDetailChange($event)"
                      />
                    }
                    @if (
                      item.container ===
                      'CommercialFacilitiesSearchContainerComponent'
                    ) {
                      <app-commercial-facilities-search-container />
                    }
                    @if (
                      item.container ===
                      'CommercialFacilityDetailsContainerComponent'
                    ) {
                      <app-commercial-facility-details-container
                        [id]="item.id!"
                        [index]="item.index"
                        (changesEvent)="handleDetailChange($event)"
                      />
                    }
                    @if (
                      item.container ===
                      'CommercialOutagesSearchContainerComponent'
                    ) {
                      <app-commercial-outages-search-container />
                    }
                    @if (
                      item.container ===
                      'CommercialOutageDetailContainerComponent'
                    ) {
                      <app-commercial-outage-detail-container
                        [id]="item.id!"
                        [index]="item.index"
                        (changesEvent)="handleDetailChange($event)"
                      />
                    }
                    @if (
                      item.container ===
                      'CommercialOperationalNotesSearchContainerComponent'
                    ) {
                      <app-commercial-operational-notes-search-container />
                    }
                  </div>
                </div>
              </p-tabpanel>
            }
          </p-tabpanels>
        </p-tabs>
      }
    } @else {
      <router-outlet />
    }

    <p-confirmDialog
      header="{{ 'COMMON.LABEL.HEADERS.CONFIRMATION' | translate }}"
    />
  </div>
</div>

<p-dialog
  header="Loading Application"
  [(visible)]="showLoadingScreen"
  showEffect="fade"
  [modal]="true"
  [transitionOptions]="'0ms'"
  [style]="{ width: '500px' }"
>
  <div id="loading-screen">
    <div>
      <div>Loading user information...</div>
      @if (loadingStatus.user === null) {
        <div>
          <app-progress-spinner [enabled]="!loadingStatus.user" />
        </div>
      }
      @if (loadingStatus.user === false) {
        <div>
          <i class="fa fa-fw fa-exclamation-triangle"></i>
        </div>
      }
      @if (loadingStatus.user === true) {
        <div>
          <i class="fa fa-fw fa-check"></i>
        </div>
      }
    </div>
  </div>
</p-dialog>

<app-privacy-consent-container
  [displayDialog]="showPrivacyDialog"
  (policyAcceptedEvent)="policyAccepted()"
/>
